import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { EditProductMutation as EditProduct, EditProductInput } from '__generated__/graphql';
import { useNotifier } from '../../../../common/Notifications/NotificationProvider';
import EditProductMutation from './EditProductMutation';
import useScroll from '../../../../common/useScroll';

interface UseEditProductMutationProps {
  input: EditProductInput,
  onSuccess?: (product: EditProduct['editProduct']) => void;
}

const useEditProductMutation = ({ input, onSuccess }: UseEditProductMutationProps) => {
  const { t } = useTranslation();
  const notifier = useNotifier();
  const { scrollToIfInvisible } = useScroll();

  return useMutation(EditProductMutation, {
    variables: {
      input,
    },
    onCompleted: ({ editProduct: product }) => {
      notifier.success(t('notifications.product_saved'));

      onSuccess?.(product);
    },
    onError: () => {
      scrollToIfInvisible(`ProductCard_${input.id}`);
    },
  });
};

export default useEditProductMutation;
